import { __rest } from "tslib";
import * as React from 'react';
import MUITooltip from '@mui/material/Tooltip';
import cn from 'classnames';
import { useTheme } from '../../theme';
import { SafeHtml } from '@shared/ui';
const Tooltip = (_a) => {
    var { title, children, titleClassName, tooltipClassName, popperClassName, arrowClassName, placement = 'top', PopperProps } = _a, restProps = __rest(_a, ["title", "children", "titleClassName", "tooltipClassName", "popperClassName", "arrowClassName", "placement", "PopperProps"]);
    const { Tooltip: css } = useTheme('BaseComponents');
    const titleClasses = cn(css.title, titleClassName);
    const titleElement = typeof title === 'string' ? (React.createElement(SafeHtml, { tag: "span", className: titleClasses, html: title })) : (React.createElement("span", { className: titleClasses }, title));
    return (React.createElement(MUITooltip, Object.assign({ title: titleElement, placement: placement, arrow: true, PopperProps: PopperProps, classes: {
            tooltip: cn(css.tooltip, tooltipClassName),
            popper: cn(css.popper, popperClassName),
            arrow: cn(css.tooltip_arrow, arrowClassName)
        } }, restProps), children));
};
export default Tooltip;
